import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { MeteringPointAction } from './types';

export const meteringPointActionsApi = createApi({
  reducerPath: 'meteringPointActionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-point-actions`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringPointActions: builder.query<MeteringPointAction[], void>({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetMeteringPointActionsQuery } = meteringPointActionsApi;
